const defaultNumberOfDecimals = 3;

export abstract class Formatter {
  constructor(protected readonly numberDecimals: number = defaultNumberOfDecimals) {
  }

  abstract apply(value: any, args?: any): any;
}
